export function ProductsGridSkeleton() {
  return (
    <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className='rounded-3xl bg-white p-5 lg:p-6 shadow-[0px_4px_24px_0px_rgba(15,22,30,0.08)] w-full max-w-sm animate-pulse'
        >
          <div className='flex flex-col'>
            <div className='h-5 w-5 bg-alba-gray-200 rounded' />

            <div className='mt-3'>
              <div className='h-6 bg-alba-gray-200 rounded w-32' />
              <div className='mt-2 h-4 bg-alba-gray-200 rounded w-full' />
              <div className='mt-2 h-4 bg-alba-gray-200 rounded w-3/4' />
            </div>
          </div>

          <div className='mt-5 border-t border-alba-gray-200 w-full' />

          <div className='mt-3 flex items-center justify-between'>
            <div className='h-5 bg-alba-gray-200 rounded w-12' />
            <div className='h-6 w-6 bg-alba-gray-200 rounded-full' />
          </div>
        </div>
      ))}
    </div>
  );
}
